module.exports = __webpack_public_path__ + "img/index_back2@2x.2b2921aa.png";